<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          친구추천 이벤트
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            이벤트 관리 → 친구추천 이벤트
          </div>
        </h5>
        <query-grid :config="config" ref="qg">
          <template #actions> </template>
          <template #items="props">
            <tr
              v-for="record in props.records"
              v-bind:key="record.id"
              :class="{ 'table-danger': record.is_deleted }"
            >
              <td
                style="text-align: center"
                v-if="
                  this.$root.guiPerm != 'CLASS' &&
                  this.$root.guiPerm != 'ENTERPRISE'
                "
              >
                <Business v-if="record.t2" :biz="record.t2" />
              </td>
              <td scope="row" style="text-align: center">{{ record.id }}</td>
              <td style="text-align: center">{{ record.username }}</td>
              <td style="text-align: center"><Student :student="record" /></td>
              <td style="text-align: center">
                <span v-if="record.gender === '1'">남</span>
                <span v-if="record.gender === '2'">여</span>
              </td>
              <td style="text-align: center">
                <span v-if="record.type === 'MYPATH'">MY PATH</span>
                <span v-if="record.type === 'MYUSE'">MY USE</span>
              </td>
              <td style="text-align: center">
                <span
                  v-if="!record.active_subscription_id"
                  style="
                    background: #ff0000;
                    color: #fff;
                    padding: 2px 6px;
                    font-size: 12px;
                  "
                  >미사용</span
                ><template v-else
                  ><span
                    v-if="record.ranking_exception"
                    style="
                      background: #ffcc00;
                      color: #333;
                      padding: 2px 6px;
                      font-size: 12px;
                    "
                    >이벤트</span
                  ><span
                    v-else
                    style="
                      background: #0071e3;
                      color: #fff;
                      padding: 2px 6px;
                      font-size: 12px;
                    "
                    >정회원</span
                  ></template
                >
              </td>
              <td style="text-align: center">{{ record.recommender_id }}</td>
              <td style="text-align: center">
                {{ record.recommender_username }}
              </td>
              <td style="text-align: center">
                {{ record.recommender_hanname }}
              </td>
              <td style="text-align: center">
                <span v-if="record.recommender_gender === '1'">남</span>
                <span v-if="record.recommender_gender === '2'">여</span>
              </td>
              <td style="text-align: center">
                <span v-if="record.recommender_type === 'MYPATH'">MY PATH</span>
                <span v-if="record.recommender_type === 'MYUSE'">MY USE</span>
              </td>
              <td style="text-align: center">
                <span
                  v-if="!record.recommender_active_subscription_id"
                  style="
                    background: #ff0000;
                    color: #fff;
                    padding: 2px 6px;
                    font-size: 12px;
                  "
                  >미사용</span
                ><template v-else
                  ><span
                    v-if="record.recommender_ranking_exception"
                    style="
                      background: #ffcc00;
                      color: #333;
                      padding: 2px 6px;
                      font-size: 12px;
                    "
                    >이벤트</span
                  ><span
                    v-else
                    style="
                      background: #0071e3;
                      color: #fff;
                      padding: 2px 6px;
                      font-size: 12px;
                    "
                    >정회원</span
                  ></template
                >
              </td>
            </tr>
          </template>
        </query-grid>
      </div>
    </div>
  </div>

  <Tree
    :key="$route.path"
    :tree-data="this.$root.businesses"
    :selectable="['CLASS']"
    render-button
    :callback="selectedBiz"
    :selectedNode="{ id: selData.activeBusiness }"
    ref="biz"
  />
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import axios from "axios";
import VueCookies from "vue-cookies";
import Student from "../components/detail_pages/Student.vue";
export default {
  name: "Home",
  components: {
    Tree,
    treeBtn,
    Business,
    Student,
    QueryGrid,
  },
  mounted() {
    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      this.config.columns.splice(0, 1);
    }

    this.$refs.qg.search();
  },
  methods: {
    getDiff(value) {
      var moment = require("moment"); // moment 모듈불러오기

      const diff = moment().diff(value, "hours");
      const days = Math.floor(diff / 24);
      const hours = diff % 24;

      return -days;
    },
  },
  data() {
    return {
      config: {
        name: "학생 리스트",
        req_endpoint: "/recommender_students",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "prod_filter",
            name: "상품유형",
            type: "switch",
            filter_type: {
              MYUSE: "My USE",
              MYPATH: "MyPath",
            },
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "아이디/이름/회원번호/학원/클래스",
          },
          {
            id: "date_filter",
            name: "날짜검색",
            type: "date",
            filter_type: {
              start_date: "시작일",
              end_date: "종료일",
            },
          },
        ],
        columns: [
          {
            id: "biz",
            name: "학원/캠퍼스",
            excel_print: (v) => {
              return v.t2.name;
            },
          },
          {
            id: "id",
            name: "회원번호",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "username",
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "hanname",
            name: "이름",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "gender",
            name: "성별",
            excel_print: (v) => {
              return v.gender == "1" ? "남" : "여";
            },
          },
          {
            id: "type",
            name: "상품유형",
            excel_print: (v) => {
              return v.type || "";
            },
          },
          {
            id: "status",
            name: "상태",
            excel_print: (v) => {
              return v.active_subscription_id
                ? v.ranking_exception
                  ? "이벤트"
                  : "정회원"
                : "미사용";
            },
          },
          {
            id: "recommender_id",
            name: "추천인회원번호",
            excel_print: (v) => {
              return v.recommender_id;
            },
          },
          {
            id: "recommender_username",
            name: "추천인아이디",
            excel_print: (v) => {
              return v.recommender_username;
            },
          },
          {
            id: "recommender_hanname",
            name: "추천인이름",
            excel_print: (v) => {
              return v.recommender_hanname;
            },
          },
          {
            id: "recommender_gender",
            name: "추천인성별",
            excel_print: (v) => {
              return v.recommender_gender == "1" ? "남" : "여";
            },
          },
          {
            id: "recommender_type",
            name: "추천인상품유형",
            excel_print: (v) => {
              return v.recommender_type || "";
            },
          },
          {
            id: "recommender_status",
            name: "추천인상태",
            excel_print: (v) => {
              return v.recommender_active_subscription_id
                ? v.recommender_ranking_exception
                  ? "이벤트"
                  : "정회원"
                : "미사용";
            },
          },
        ],
        disable_init_search: true,
      },

      selData: {
        id: "",
        activeBusiness: "",
        username: "",
        password: "",
        hanName: "",
        engName: "",
        parentName: "",
        gender: "",
        bookclub_status: "",
        vocajoa_status: "",
        uracle_status: "",
        birth_of_day: "",
        phone: "",
        parentName: "",
        parentPhone: "",
        address: "",
        pass_allowed: false,
        recommender: "",
      },
    };
  },
};
</script>
